import { morphism } from 'morphism';

import { organizationResponse } from '@hero/schemas';

import { api } from './api';
import { endpoints } from './endpoints';

const checkUserExistence = (email, merchantCode) =>
  api
    .post(endpoints.checkUserExistence(), {
      email,
      merchantCode
    })
    .then(res => {
      return res?.data?.data;
    });

const getOrganizationUsers = params =>
  api
    .get(endpoints.organizationUsers(), { params })
    .then(res => morphism(organizationResponse.getOrganizationUsers, res?.data?.data));

const connectSalesforce = authCode =>
  api.post(endpoints.connectSalesforce(), authCode).then(res => {
    return res?.data?.data;
  });

const createInvite = body =>
  api.post(endpoints.createInvite(), body).then(res => {
    return res?.data?.data;
  });

const getBranding = () =>
  api.get(endpoints.branding()).then(res => {
    return morphism(organizationResponse.setBranding, res?.data?.data);
  });

const getPaymentMethods = params =>
  api
    .get(endpoints.paymentMethods(), {
      params
    })
    .then(res => {
      return morphism(organizationResponse.getPaymentMethods, res?.data?.data);
    });

const getProviderUrl = () =>
  api.get(endpoints.getProviderUrl()).then(res => {
    return res?.data?.data;
  });

const getUser = () =>
  api.get(endpoints.user()).then(res => {
    return morphism(organizationResponse.getUserData, res?.data?.data);
  });

const getOrganizationUser = ({ userCode }) =>
  api.get(endpoints.organizationUser(userCode)).then(res => {
    return morphism(organizationResponse.getUserData, res?.data?.data);
  });

const resendCode = email =>
  api
    .post(endpoints.resendCode(), {
      email
    })
    .then(res => {
      return res?.data?.data;
    });

const selectOrganization = ({ organizationCode }) =>
  api.get(endpoints.selectOrganization(organizationCode)).then(res => res?.data?.data);

const sendAuthEmail = email =>
  api
    .post(endpoints.sendAuthEmail(), {
      email
    })
    .then(res => {
      return res?.data?.data;
    });

const checkEmails = body =>
  api.post(endpoints.checkEmails(), body).then(res => {
    return res?.data?.data;
  });

const sendToApproval = params =>
  api.post(endpoints.sendToApproval(), params).then(res => res?.data?.data);

const setBranding = params =>
  api.post(endpoints.branding(), params).then(res => {
    return morphism(organizationResponse.setBranding, res?.data?.data);
  });

const signInWithCode = params =>
  api
    .post(endpoints.signInWithCode(), params)
    .then(res => morphism(organizationResponse.signInWithCode, res?.data?.data));

const signUpUser = data =>
  api.post(endpoints.signUp(), data).then(res => {
    return res?.data?.data;
  });

const updateOrganization = (organizationCode, params) =>
  api.put(endpoints.organizations(organizationCode), params).then(res => {
    return res?.data?.data;
  });

const updateUser = data =>
  api.put(endpoints.user(), data).then(res => {
    return res?.data?.data;
  });

const requestChangePassword = data =>
  api.post(endpoints.changePassword(), data).then(res => {
    return res?.data?.data;
  });

const updateCompany = data => api.put(endpoints.updateCompany(), data).then(res => res?.data?.data);

const resendInviteOrganizationUser = body =>
  api.post(endpoints.resendInvite(), body).then(res => {
    return res?.data?.data;
  });

const getOrganizationUsersCount = () =>
  api.get(endpoints.organizationUsersCount()).then(res => {
    return res?.data?.data;
  });

const removeOrganizationUser = body =>
  api.post(endpoints.removeOrganizationUsers(), body).then(res => {
    return res?.data?.data;
  });

const updateOrganizationUser = (userCode, body) =>
  api.put(endpoints.organizationUser(userCode), body).then(res => {
    return morphism(organizationResponse.getUserData, res?.data?.data);
  });

const verifySignUp = (verificationCode, verificationToken) =>
  api
    .post(endpoints.verifySignUp(), {
      verificationCode,
      verificationToken
    })
    .then(res => {
      return res?.data?.data;
    });

const getInvite = ({ params }) =>
  api.get(endpoints.getInvite(), { params }).then(res => {
    return res.data.data;
  });

const acceptInvite = ({ body }) =>
  api.post(endpoints.acceptInvite(), body).then(res => {
    return res?.data?.data;
  });

export {
  acceptInvite,
  checkEmails,
  checkUserExistence,
  connectSalesforce,
  createInvite,
  getBranding,
  getInvite,
  getOrganizationUser,
  getOrganizationUsers,
  getOrganizationUsersCount,
  getPaymentMethods,
  getProviderUrl,
  getUser,
  removeOrganizationUser,
  requestChangePassword,
  resendCode,
  resendInviteOrganizationUser,
  selectOrganization,
  sendAuthEmail,
  sendToApproval,
  setBranding,
  signInWithCode,
  signUpUser,
  updateCompany,
  updateOrganization,
  updateOrganizationUser,
  updateUser,
  verifySignUp
};
